<!-- Need to implement code for supporting tables -->
<!-- Currently only one signature on a single page is supported. Need to handle multiple signatures on single page -->
<template>
  <div>
    <div v-for="child in mappings" :key="child.path">
      <div v-if="child.map_type === 'shape'">
        <b-row class="pt-2" v-if="child.data_type === 'date'">
          <b-col cols="4">
            <label>{{ child['key'] }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">This is a required field.</h6>
          </b-col>
          <b-col cols="4">
            <input class="form-control" type="date" @input="updateFormField($event, child.id, child.data_type)">
          </b-col>
        </b-row>
        <b-row class="pt-2" v-else-if="child.data_type === 'checkbox'">
          <b-col cols="4">            
            <label>{{ child.key | capitalize }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">This is a required field.</h6>
          </b-col>
          <b-col cols="1">
            <input type="checkbox" @input="updateFormField($event, child.id, child.data_type)">
          </b-col>
        </b-row>
        <b-row class="pt-2" v-else-if="child.data_type === 'email'">
          <b-col cols="4">
            <label>{{ child['key'] }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">This is a required field.</h6>
          </b-col>
          <b-col cols="4">
            <input class="form-control" type="email" @input="updateFormField($event, child.id, child.data_type)" />
          </b-col>
        </b-row>
        <b-row class="pt-2" v-else-if="child.data_type === 'numeric' || child.data_type === 'phone' || 
                        child.data_type === 'fax' || child.data_type === 'npi' || child.data_type === 'zip'">
          <b-col cols="4">
            <label>{{ child['key'] }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">This is a required field.</h6>
          </b-col>
          <b-col cols="4">
            <input class="form-control" type="number" @input="updateFormField($event, child.id, child.data_type)" />
          </b-col>
        </b-row>
        <b-row class="pt-2" v-else-if="child.data_type === 'signature'">
          <b-col cols="4">
            <label>{{ child['key'] }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">Please save after signing.</h6>
          </b-col>
          <b-col cols="4">
            <VueSignaturePad class="signature" width="100%" height="100px"
                             :ref="'signaturePad_'+child.id" :options="options"
                              @input="updateFormField($event, child.id, child.data_type)"/>
            <div class="pt-1 pull-right" syle="width:100%">
              <b-button size="sm" variant="primary" @click="undoSignature(child.id)">Undo</b-button>
              <b-button size="sm" variant="danger" @click="resetSignature(child.id)">Clear</b-button>
              <b-button size="sm" variant="success" @click="saveSignature(child.id)">Save</b-button>
            </div>
          </b-col>
        </b-row>
        <b-row class="pt-2" v-else>
          <b-col cols="4">
            <label>{{ child['key'] }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">This is a required field.</h6>
          </b-col>
          <b-col cols="4">
            <input class="form-control" type="text" @input="updateFormField($event, child.id, child.data_type)" />
          </b-col>
        </b-row>
      </div>
      <div v-else-if="child.map_type === 'group'">
        <div class="pt-2" v-if="child.data_type === 'logical' || child.data_type === 'npi' ||
                    child.data_type === 'combine_data' || child.data_type === 'checkbox_text'">
          <b-col cols="12" class="p-0">
            <h4>{{ child.key | capitalize }}</h4>
          </b-col>
          <form-data-tree :templateId="templateId" :mappings="child.children" :dataBus="dataBus"
                          :showErrors="showErrors" :formErrors="formErrors"></form-data-tree>
        </div>
        <b-row class="pt-2" v-else-if="child.data_type === 'single_select'">
          <b-col cols="4">
            <label>{{ child.key | capitalize }}</label>
            <sup v-if="child.required" class="text-danger required-css">
              <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">Please select an option.</h6>
          </b-col>
          <b-col cols="8">
            <div class="single-select" v-for="radioInput in child.children" :key="radioInput.path">
              <input type="radio" :name="'child_'+child.id"
                      @input="updateFormField($event, radioInput.id, radioInput.data_type, child.id, 'single_select')" />
              <label>{{ radioInput.key }}</label>
            </div>
          </b-col>
        </b-row>
        <b-row class="pt-2" v-else-if="child.data_type === 'multi_select'">
          <b-col cols="4">
            <label>{{ child.key | capitalize }}</label>
            <sup v-if="child.required" class="text-danger required-css">
                <i class="fa fa-asterisk"></i>
            </sup>
            <h6 class="error-msg" v-if="shouldShowError(child.id)">Please select atleast one option.</h6>
          </b-col>
          <b-col cols="8">
            <div class="multi-select" v-for="checkboxInput in child.children" :key="checkboxInput.path">
              <input type="checkbox" :name="'child_'+child.id"
                      @input="updateFormField($event, checkboxInput.id, checkboxInput.data_type)">
              <label>{{ checkboxInput.key }}</label>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)

export default {
  name: 'form-data-tree',
  props: ['templateId', 'mappings', 'dataBus', 'showErrors', 'formErrors'],
  data () {
    return {
      options: {
        penColor: '#000000'
      }
    }
  },
  components: {
    'date-picker': DatePicker
  },
  methods: {
    shouldShowError (id) {
      return this.showErrors && this.formErrors[id]
    },
    undoSignature (id) {
      this.$refs['signaturePad_' + id][0].undoSignature()
    },
    resetSignature (id) {
      this.$refs['signaturePad_' + id][0].clearSignature()
    },
    saveSignature (id) {
      let { data } = this.$refs['signaturePad_' + id][0].saveSignature()
      this.dataBus.$emit('updateFormField', this.templateId, id, data || '')
    },
    updateFormField (event, id, dataType, parentId = null, parentType = null) {
      let value = (dataType === 'checkbox') ? event.target.checked : event.target.value && event.target.value.trim()
      this.dataBus.$emit('updateFormField', this.templateId, id, value, parentId, parentType)
    }
  }
}
</script>
<style lang="scss" scoped>

.form-control {
  border-radius: 5px;
}

label {
  font-size: medium;
}

.error-msg {
  color: red;
  font-style: italic;
}

.signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance:textfield;
}

.single-select,
.multi-select {
  display: inline-block;
  margin-right: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/submit/formDataTree.vue